import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormView from "./FormView";
import DialogModal from "../Common/DialogModal";
import { showDialog } from "../../appRedux/actions/common";
import { setSubscriptionInfo } from "../../appRedux/actions/subscriptions";

function EditInfo({ info, merchantCode }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { dialog } = useSelector((state) => ({
    dialog: state.common.dialog,
  }));

  useEffect(() => {
    if (!dialog) setOpen(dialog);
  }, [dialog]);

  const onClick = () => {
    setOpen(true);
    dispatch(setSubscriptionInfo(info));
    dispatch(showDialog({ title: "Edit Subscription", size: "lg", id: info._id }));
  };

  return (
    <Fragment>
      <button
        className="dropdown-item"
        onClick={onClick}
        key="edit_subscription"
      >
        <i className="fa fa-pencil m-r-5" /> Edit
      </button>
      {open && (
        <DialogModal
          infoId={info._id}
          bodyView={<FormView isUpdate={true} merchantCode={merchantCode} />}
        />
      )}
    </Fragment>
  );
}

export default EditInfo;
